<div class="tools-outer-container">
  @if ((tools$ | async)?.includes(PresenterToolsEnum.TEXT)) {
    @if ((selectedWidgetType$ | async) === WidgetType.SMART_TEXT) {
      <gb-presenter-tools-smart-text
        [uuid]="uuid$ | async"
        [toolsFormGroup]="toolsFormGroup"
      ></gb-presenter-tools-smart-text>
    } @else {
      <gb-presenter-tools-text-widget [toolsFormGroup]="toolsFormGroup"></gb-presenter-tools-text-widget>
    }
  }
  @if ((tools$ | async)?.includes(PresenterToolsEnum.ITEM_TABLE)) {
    <gb-presenter-tools-item-table [toolsFormGroup]="toolsFormGroup"></gb-presenter-tools-item-table>
  }
  @if ((tools$ | async)?.includes(PresenterToolsEnum.TOTAL_RAISED)) {
    <gb-presenter-tools-total-raised [toolsFormGroup]="toolsFormGroup"></gb-presenter-tools-total-raised>
  }
  @if ((tools$ | async)?.includes(PresenterToolsEnum.COUNTDOWN)) {
    <gb-presenter-tools-countdown
      [toolsFormGroup]="toolsFormGroup"
      [auctionScheduledEnd]="auctionScheduledEnd$ | async"
      [auctionTimezone]="(auctionTimezone$ | async) || 'UTC'"
      [auctionOvertimeEnabled]="auctionOvertimeEnabled$ | async"
      [allowPastEndDate]="true"
    ></gb-presenter-tools-countdown>
  }
  @if ((tools$ | async)?.includes(PresenterToolsEnum.HONOUR_ROLL)) {
    <gb-presenter-tools-honour-roll [toolsFormGroup]="toolsFormGroup"></gb-presenter-tools-honour-roll>
  }
  @if ((tools$ | async)?.includes(PresenterToolsEnum.RAFFLE_DRAW)) {
    <gb-presenter-tools-raffle-draw
      [toolsFormGroup]="toolsFormGroup"
      (preview)="onPreviewWidget(WidgetType.RAFFLE_DRAW)"
      (resetPreview)="onResetPreviewWidget(WidgetType.RAFFLE_DRAW)"
      [isTemplateMode]="isTemplateMode"
    ></gb-presenter-tools-raffle-draw>
  }
  @if ((tools$ | async)?.includes(PresenterToolsEnum.RAFFLE_WINNERS)) {
    <gb-presenter-tools-raffle-winners-list
      [toolsFormGroup]="toolsFormGroup"
      [editMode]="true"
      [isTemplateMode]="isTemplateMode"
      (preview)="onPreviewWidget(WidgetType.RAFFLE_WINNERS)"
      (resetPreview)="onResetPreviewWidget(WidgetType.RAFFLE_WINNERS)"
    ></gb-presenter-tools-raffle-winners-list>
  }
  @if ((tools$ | async)?.includes(PresenterToolsEnum.THERMOMETER)) {
    <gb-presenter-tools-thermometer [toolsFormGroup]="toolsFormGroup"></gb-presenter-tools-thermometer>
  }

  @if ((tools$ | async)?.includes(PresenterToolsEnum.NOTIFICATION)) {
    <gb-presenter-tools-notification
      [toolsFormGroup]="toolsFormGroup"
      (preview)="previewNotification.emit($event)"
    ></gb-presenter-tools-notification>
  }

  @if ((tools$ | async)?.includes(PresenterToolsEnum.QR_CODE)) {
    <gb-presenter-tools-qr-code [toolsFormGroup]="toolsFormGroup"></gb-presenter-tools-qr-code>
  }

  @if ((tools$ | async)?.includes(PresenterToolsEnum.TEAM_SCORING)) {
    <gb-presenter-tools-team-scoring [toolsFormGroup]="toolsFormGroup"></gb-presenter-tools-team-scoring>
  }

  @if ((tools$ | async)?.includes(PresenterToolsEnum.POWER_PLEDGE)) {
    <gb-presenter-tools-power-pledge [toolsFormGroup]="toolsFormGroup"></gb-presenter-tools-power-pledge>
  }

  @if ((tools$ | async)?.includes(PresenterToolsEnum.VIDEO)) {
    <gb-presenter-tools-video [toolsFormGroup]="toolsFormGroup"></gb-presenter-tools-video>
  }

  @if ((tools$ | async)?.includes(PresenterToolsEnum.LAYOUT)) {
    <gb-presenter-tools-layout
      [toolsFormGroup]="toolsFormGroup"
      (alignLeft)="alignLeft.emit()"
      (alignRight)="alignRight.emit()"
      (alignTop)="alignTop.emit()"
      (alignBottom)="alignBottom.emit()"
      (alignHorizontalCenter)="alignHorizontalCenter.emit()"
      (alignVerticalCenter)="alignVerticalCenter.emit()"
      (bringToFront)="bringToFront.emit()"
      (bringForward)="bringForward.emit()"
      (sendBackward)="sendBackward.emit()"
      (sendToBack)="sendToBack.emit()"
    ></gb-presenter-tools-layout>
  }
</div>
